import * as constants from '../constants';
import { createReducer } from '../../../utils';

const initialState = {
  isWebtourOverlayVisible: true,
};
export default createReducer(initialState, {
  [constants.TOGGLE_WEBTOUR_OVERLAY]: (state, payload) => ({
    ...state, isWebtourOverlayVisible: payload.isWebtourOverlayVisible,
  }),
});
